import FamilytreeStyles from './FamilytreeStyles';

const {
  MShape, FShape, UKNShape, activeFShape, activeMShape, activeUKNShape,
} = FamilytreeStyles.nodeStyles;

class PedigreeNester {
  static convertFlatJSONPedigreeToNestedMaternalPedigree(
    pedigree,
    activeElephantPk,
  ) {
    if (pedigree.length <= 0) return [];
    const filteredPedigree = this.getAllMaternalAndActiveElephantRelationships(
      pedigree, activeElephantPk,
    );
    if (filteredPedigree.length <= 0) return [];
    const oldestElephant = this.getOldestElephant(filteredPedigree);

    const nestedPedigree = [
      {
        name: oldestElephant.name || 'Name not found',
        elephantId: oldestElephant.pk,
        nodeSvgShape: this.getNodeShape(oldestElephant, activeElephantPk),
        attributes: {
          num: oldestElephant.num || '-',
          birth: oldestElephant.birth,
          sex: oldestElephant.sex,
        },
      },
    ];

    const children = this.getAllChildren(oldestElephant, filteredPedigree)
      .sort((a, b) => {
        if (a.birth < b.birth) return -1;
        return 1;
      });

    if (children.length > 0) {
      nestedPedigree[0].children = this.nestChildrenOfAncestor(
        oldestElephant,
        filteredPedigree.filter(rel => rel.elephant_2.pk !== oldestElephant.pk),
        activeElephantPk,
      );
    }
    return nestedPedigree;
  }

  static getAllMaternalAndActiveElephantRelationships(pedigree, activeElephantPk) {
    return pedigree.filter(relationship => (relationship.rel === 'mother')
    || (relationship.elephant_1.pk === activeElephantPk && relationship.rel === 'father'));
  }

  static getNodeShape(elephant, activeElePk) {
    return elephant.pk === activeElePk
      ? this.highlightNode(elephant)
      : elephant.sex === 'F'
        ? FShape
        : elephant.sex === 'M'
          ? MShape
          : UKNShape;
  }

  static highlightNode(elephant) {
    if (elephant.sex === 'F') return activeFShape;
    if (elephant.sex === 'M') return activeMShape;
    return activeUKNShape;
  }

  static nestChildrenOfAncestor(ancestor, pedigree, activeElephantPk) {
    const ancestorElephant = ancestor;
    let nestedPedigree = {};
    const children = this.getAllChildren(ancestorElephant, pedigree)
      .sort((a, b) => {
        if (a.birth < b.birth) return -1;
        return 1;
      });
    if (children.length > 0) {
      nestedPedigree = children.map(child => ({
        name: this.handleName(child.name) || '( No name )',
        elephantId: child.pk,
        nodeSvgShape: this.getNodeShape(child, activeElephantPk),
        attributes: {
          num: child.num || '-',
          birth: child.birth,
          sex: child.sex,
        },
        children: this.nestChildrenOfAncestor(
          child,
          pedigree.filter(rel => rel.elephant_2.pk !== child.pk),
          activeElephantPk,
        ),
      }));
    }
    return nestedPedigree;
  }

  static handleName(name) {
    if (!name) return '';
    if (name.length < 18) return name;
    return `${name.slice(0, 16)}...`;
  }

  static getOldestElephant(pedigree) {
    let ancestorRelationship = pedigree[0];
    let oldestAncestorRelationship;
    const processedElephantIds = [];
    while (ancestorRelationship) {
      oldestAncestorRelationship = ancestorRelationship;
      if (processedElephantIds.includes(ancestorRelationship.elephant_1.pk)) {
        break;
      }
      ancestorRelationship = this.getRelationshipWithParentIfExists(
        ancestorRelationship.elephant_1,
        pedigree,
      );
      processedElephantIds.push(oldestAncestorRelationship.elephant_1.pk);
    }
    return oldestAncestorRelationship.elephant_1;
  }

  static getRelationshipWithParentIfExists(ancestor, pedigree) {
    return (
      pedigree.find(
        relationship => relationship.elephant_2.pk === ancestor.pk
        && (relationship.rel === 'mother' || relationship.rel === 'father'),
      ) || null
    );
  }

  static getAllChildren(ancestor, pedigree) {
    const childrenRelationshipArray = pedigree.filter(
      relationship => relationship.elephant_1.pk === ancestor.pk,
    );

    return childrenRelationshipArray.map(
      relationship => relationship.elephant_2,
    );
  }

  static getFatherOf(elephantPk, treeData) {
    const fatherRelationship = treeData.find(
      relationship => relationship.elephant_2.pk === elephantPk
        && relationship.rel === 'father',
    );
    if (fatherRelationship) return fatherRelationship.elephant_1;
    return null;
  }
}

export default PedigreeNester;



// WEBPACK FOOTER //
// ./src/components/familytree/PedigreeHelper.jsx